import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useRouteParams } from '../../hooks/useRouteParams';
import Icon from '../../styled/Icon/Icon';
import boxTemplates from '../../templates/box';
import {
  TemplateSelectorWrapper,
  TemplateSelectorToggle,
  TemplateSelectorMenu,
  TemplateSelectorList,
  TemplateSelectorToggleBack,
  TemplateSelectorListWrapper,
  TemplateListWrapper,
} from './TemplateSelector.styles';

interface TemplateSelectorProps {}

const templateSelectorVarients = {
  init: {
    x: 276,
  },
  enter: {
    x: 0,
  },
  exit: {
    x: 276,
  },
};

const TemplateSelector: React.FC<TemplateSelectorProps> = () => {
  const { type } = useRouteParams();
  const [showList, setShowList] = useState(false);
  return (
    <TemplateSelectorWrapper>
      <TemplateSelectorToggle type="button" onClick={() => setShowList(true)}>
        <span>{type}</span>
        <Icon className="edit" type="edit-pencil" />
        <Icon className="arrow" type="arrow-right" />
      </TemplateSelectorToggle>
      <AnimatePresence>
        {showList && (
          <TemplateListWrapper>
            <TemplateSelectorMenu
              as={motion.div}
              variants={templateSelectorVarients}
              transition={{
                // stiffness: 35,
                // type: 'tween',
                duration: 0.8,
                ease: 'anticipate',
              }}
              initial="exit"
              animate="enter"
              exit="exit"
            >
              <TemplateSelectorToggleBack
                type="button"
                onClick={() => setShowList(false)}
              >
                <Icon className="arrow" type="arrow-left" />
                <span>Select Template</span>
                <span />
              </TemplateSelectorToggleBack>
              <TemplateSelectorListWrapper>
                {(
                  Object.keys(boxTemplates) as Array<keyof typeof boxTemplates>
                ).map((t) => (
                  <TemplateSelectorList key={t}>
                    <div>{t}</div>
                    {boxTemplates[t].map(({ name }) => (
                      <li key={name}>
                        <Link to={`/${t}/${name}`}>{name}</Link>
                      </li>
                    ))}
                  </TemplateSelectorList>
                ))}
              </TemplateSelectorListWrapper>
            </TemplateSelectorMenu>
          </TemplateListWrapper>
        )}
      </AnimatePresence>
    </TemplateSelectorWrapper>
  );
};

export default TemplateSelector;
